import $axios from '@/helpers/axios-instance';

const baseUrl = process.env.API_STUDENTS_URL;

export default {
  getStudents(paging) {
    return $axios.get(
      `api/v1/student/page/${paging.page}/pagesize/${paging.pageSize}`,
      { baseURL: baseUrl },
    );
  },
  createStudent(student) {
    return $axios.post('api/v1/student', student, { baseURL: baseUrl });
  },
  updateStudent(student) {
    return $axios.put(`api/v1/student/${student.id}`, student, {
      baseURL: baseUrl,
    });
  },
  createStudents(students) {
    return $axios.post('api/v1/student/multiple', students, {
      baseURL: baseUrl,
    });
  },
};



// WEBPACK FOOTER //
// ./src/api/students.js